<script setup>
defineProps({
  article: {
    type: Object,
    default: () => ({
      title: '3 tips to becoming a Vue.js Developer',
      description: 'Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.',
      slug: '3-tips-to-becoming-a-vue-js-developer',
      thumbnail_url: '/images/article-test.png',
      published_at: '2024-01-25T12:00:00+02:00',
      author: {
        name: 'John Doe',
        avatar: '/images/avatar-test.png'
      }
    })
  },
  target: {
    type: String,
    default: '_blank'
  }
})

const { formatDate } = useHelpers()
</script>

<template>
  <NuxtLink
    :to="'/blog/' + article.slug"
    :target="target"
    class="group  flex shrink-0 flex-col overflow-hidden rounded-3xl bg-white hover:bg-[#2C2F3A]/10 dark:bg-[#2C2F3A]/60 dark:hover:bg-[#2C2F3A]">
    <NuxtImg
      :src="article.thumbnail_url"
      class="h-auto w-full"
      :alt="article.title"
      loading="lazy" />
    <div class="flex flex-1 flex-col justify-between gap-[30px] p-[30px] md:p-10">
      <div class="flex flex-col gap-[30px]">
        <p class="text-2xl font-bold text-eerie-black dark:text-white">
          {{ article.title }}
        </p>
        <p class="max-w-sm text-base font-normal text-eerie-black dark:text-light-gray">
          {{ article.description }}
        </p>
      </div>
      <p class="text-sm font-normal text-dodger-shine md:text-base">
        {{ formatDate(article.published_at) }}
      </p>
      <div
        v-if="article.author"
        class="flex items-center gap-2">
        <div class="size-10 overflow-hidden rounded-full bg-white">
          <img
            :src="article.author.avatar || `https://avatar.iran.liara.run/username?username=${article.author.name}`"
            class="size-full object-cover object-center"
            :alt="article.author.name">
        </div>
        <p class="text-sm font-medium text-eerie-black dark:text-white">
          {{ article.author.name }}
        </p>
      </div>
    </div>
  </NuxtLink>
</template>
